export const GET_API_DATA = "GET_API_DATA";

export const dispatchConst= {
    sampleDisp:"sampleDisp",
    specialities:"specialities"
};
